<script setup lang="ts">
import { useDisplay } from 'vuetify'

const { mdAndUp } = useDisplay()

defineOptions({
  name: 'LogoComponent'
})
</script>
<template>
  <div class="logo">
    <NuxtLink to="/" aria-label="johnsenpartner. architekten — Zur Startseite">
      <div class="d-flex align-center">
        <NuxtImg
          v-if="mdAndUp"
          class="mr-4"
          src="/logo.svg"
          alt="johnsenpartner. architekten"
          height="55px"
        />
        <NuxtImg
          v-else
          class="mr-4"
          src="/logo.svg"
          alt="johnsenpartner. architekten"
          height="35px"
        />
      </div>
    </NuxtLink>
  </div>
</template>

<style scoped lang="scss">
// eslint-disable-next-line vue-scoped-css/no-unused-selector
.logo > a {
  text-decoration: none;
  color: rgba(var(--v-theme-textSecondary));
}
</style>
